(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personal-shopper-how-it-works"]) return;
  try {
    
  const cmstores = [
{formurl:'https://form.jotform.com/211526077757158', city:'Allentown, PA'},
{formurl:'https://form.jotform.com/211525258102142', city:'Alliance Ft. Worth, TX'},
{formurl:'https://form.jotform.com/211526097534153', city:'Altamonte Springs, FL'},
{formurl:'https://form.jotform.com/211525128873153', city:'Ardmore, PA'},
{formurl:'https://form.jotform.com/211525079273152', city:'Anderson, OH'},
{formurl:'https://form.jotform.com/211524979748167', city:'Ann Arbor, MI'},
{formurl:'https://form.jotform.com/211525254742148', city:'Arlington, TX'},
{formurl:'https://form.jotform.com/211526401456145', city:'Arrowhead, AZ'},
{formurl:'https://form.jotform.com/202996477856173', city:'Asheville, NC'},
{formurl:'https://form.jotform.com/211525885622155', city:'Aurora, IL'},
{formurl:'https://form.jotform.com/211525510836147', city:'Avondale, AZ'},
{formurl:'https://form.jotform.com/211526624526150', city:'Beavercreek, OH'},
{formurl:'https://form.jotform.com/211526214886154', city:'Bismarck, ND'},
{formurl:'https://form.jotform.com/211525329221143', city:'Bloomington, IL'},
{formurl:'https://form.jotform.com/211525883102146', city:'Bridgeville, PA'},
{formurl:'https://form.jotform.com/211524559380153', city:'Brookfield, WI'},
{formurl:'https://form.jotform.com/211524960044146', city:'Buford, GA'},
{formurl:'https://form.jotform.com/211525143556148', city:'Burnsville, MN'},
{formurl:'https://form.jotform.com/211525284314146', city:'Canton, OH'},
{formurl:'https://form.jotform.com/211525854923155', city:'Chandler, AZ'},
{formurl:'https://form.jotform.com/211526761505149', city:'Chapel Hill, NC'},
{formurl:'https://form.jotform.com/211525227980152', city:'Charlotte Arboretum, NC'},
{formurl:'https://form.jotform.com/211525569644158', city:'Cincinnati - Fields Ertel, OH'},
{formurl:'https://form.jotform.com/211525501121134', city:'Cincinnati - Hyde Park, OH'},
{formurl:'https://form.jotform.com/211524879073157', city:'Clarksville, TN'},
{formurl:'https://form.jotform.com/211524942788161', city:'Columbia, SC'},
{formurl:'https://form.jotform.com/211525211321134', city:'Columbus, GA'},
{formurl:'https://form.jotform.com/211524925080147', city:'Cordova, TN'},
{formurl:'https://form.jotform.com/211526254437150', city:'Crest Hill, IL'},
{formurl:'https://form.jotform.com/211524895229158', city:'Dublin, OH'},
{formurl:'https://form.jotform.com/211526401824144', city:'Eden Prairie, MN'},
{formurl:'https://form.jotform.com/211524671101139', city:'Edmond, OK'},
{formurl:'https://form.jotform.com/211245420283142', city:'Ellenton, FL'},
{formurl:'https://form.jotform.com/211524764998166', city:'Ellisville, MO'},
{formurl:'https://form.jotform.com/211524560821145', city:'Fargo, ND'},
{formurl:'https://form.jotform.com/211525565893160', city:'Fishers, IN'},
{formurl:'https://form.jotform.com/211526335102139', city:'Fort Worth Hulen, TX'},
{formurl:'https://form.jotform.com/211524735415148', city:'Fredericksburg, VA'},
{formurl:'https://form.jotform.com/211525229422145', city:'Ft Myers, FL'},
{formurl:'https://form.jotform.com/211525300814140', city:'Gahanna, OH'},
{formurl:'https://form.jotform.com/211525662545152', city:'Goshen, IN'},
{formurl:'https://form.jotform.com/211525051200132', city:'Greenville, SC'},
{formurl:'https://form.jotform.com/211525747028152', city:'Highland Village, TX'},
{formurl:'https://form.jotform.com/211526361359152', city:'Jonesboro, GA'},
{formurl:'https://form.jotform.com/211526434999163', city:'Knoxville Turkey Creek, TN'},
{formurl:'https://form.jotform.com/211526106293146', city:'Lafayette, LA'},
{formurl:'https://form.jotform.com/211526196208151', city:'Lexington, KY'},
{formurl:'https://form.jotform.com/211525434405144', city:'Liberty, MO'},
{formurl:'https://form.jotform.com/211525661840149', city:'Little Rock, AR'},
{formurl:'https://form.jotform.com/211525770768159', city:'Littleton, CO'},
{formurl:'https://form.jotform.com/211525313902142', city:'Lone Tree, CO'},
{formurl:'https://form.jotform.com/211526367488161', city:'Louisville-St Matthews, KY'},
{formurl:'https://form.jotform.com/211526064399156', city:'Louisville-Taylorsville, KY'},
{formurl:'https://form.jotform.com/211525640102137', city:'Mayfield Heights, OH'},
{formurl:'https://form.jotform.com/211526148995161', city:'McKinney, TX'},
{formurl:'https://form.jotform.com/211526467159157', city:'Minnetonka, MN'},
{formurl:'https://form.jotform.com/211525339199158', city:'Mishawaka, IN'},
{formurl:'https://form.jotform.com/211525682389160', city:'Newport News, VA'},
{formurl:'https://form.jotform.com/211525318289155', city:'North Little Rock, AR'},
{formurl:'https://form.jotform.com/211525279080150', city:'North Olmsted, OH'},
{formurl:'https://form.jotform.com/211524939959167', city:'North Richland Hills, TX'},
{formurl:'https://form.jotform.com/211525832909155', city:'Ocoee, FL'},
{formurl:'https://form.jotform.com/211525501709146', city:'Ontario, OH'},
{formurl:'https://form.jotform.com/211525274066149', city:'Orland Park, IL'},
{formurl:'https://form.jotform.com/211525213292143', city:'Overland Park, KS'},
{formurl:'https://form.jotform.com/211526574113146', city:'Palm Desert, CA'},
{formurl:'https://form.jotform.com/211525939201148', city:'Palm Harbor, FL'},
{formurl:'https://form.jotform.com/211525832201140', city:'Peoria, IL'},
{formurl:'https://form.jotform.com/211525018928152', city:'Perrysburg, OH'},
{formurl:'https://form.jotform.com/211525324504142', city:'Plantation, FL'},
{formurl:'https://form.jotform.com/211526690789164', city:'Plymouth Meeting, PA'},
{formurl:'https://form.jotform.com/211526650423145', city:'Portage, MI'},
{formurl:'https://form.jotform.com/211525885167159', city:'Rapid City, SD'},
{formurl:'https://form.jotform.com/211526256225147', city:'Reno, NV'},
{formurl:'https://form.jotform.com/211525772925156', city:'Rochester Hills, MI'},
{formurl:'https://form.jotform.com/211525808201143', city:'Rochester, MN'},
{formurl:'https://form.jotform.com/211526225693152', city:'Rock hill, SC'},
{formurl:'https://form.jotform.com/211526048880153', city:'Sandusky, OH'},
{formurl:'https://form.jotform.com/211525067699161', city:'Sarasota, FL'},
{formurl:'https://form.jotform.com/211525638379160', city:'Selma, TX'},
{formurl:'https://form.jotform.com/211525576508155', city:'Short Pump, VA'},
{formurl:'https://form.jotform.com/211526208280145', city:'South OKC, OK'},
{formurl:'https://form.jotform.com/211525262973153', city:'South Windsor, CT'},
{formurl:'https://form.jotform.com/211525978142155', city:'Spartanburg, SC'},
{formurl:'https://form.jotform.com/211525574037150', city:'Springfield, IL'},
{formurl:'https://form.jotform.com/211525121895150', city:'Springfield, PA'},
{formurl:'https://form.jotform.com/211526141737148', city:'St Louis SoCo, MO'},
{formurl:'https://form.jotform.com/211525563980155', city:'Strongsville, OH'},
{formurl:'https://form.jotform.com/211525332650143', city:'Sylvania, OH'},
{formurl:'https://form.jotform.com/211525469092154', city:'Syracuse, NY'},
{formurl:'https://form.jotform.com/211526613886157', city:'Tyler, TX'},
{formurl:'https://form.jotform.com/211524965244153', city:'Upper Arlington, OH'},
{formurl:'https://form.jotform.com/211526409524149', city:'Villa Park, IL'},
{formurl:'https://form.jotform.com/211525211909146', city:'Virginia Beach, VA'},
{formurl:'https://form.jotform.com/211525913765155', city:'Waldorf, MD'},
{formurl:'https://form.jotform.com/211526131385146', city:'West Chester, OH'},
{formurl:'https://form.jotform.com/211525813599159', city:'West Chester, PA'},
{formurl:'https://form.jotform.com/211525890867162', city:'West Seneca, NY'},
{formurl:'https://form.jotform.com/211525503657150', city:'Westerville, OH'},
{formurl:'https://form.jotform.com/211526096759161', city:'Wilmington, NC'}
];
var selectStoreOptions = document.querySelector('#store-selection');
var styleBtn = document.querySelector('#style-quiz-button');
var scrollToSection = document.querySelector('.stressed-about-your-style .button');
document.querySelector('#select-location').addEventListener('change', function(){
  const selectedState = this.value;
  selectStoreOptions.innerHTML = '<option selected>Select One</option>';
  cmstores.forEach(function(store) {
  if (store.city.includes(selectedState)) {
    var selectOption = document.createElement("option");
    selectOption.value = store.formurl;
    selectOption.text = store.city;
    selectStoreOptions.add(selectOption, null);
  }
});
  if(selectStoreOptions.length <= 1){
  selectStoreOptions.innerHTML = '<option selected>No Locations Available</option>';
  }
});
  selectStoreOptions.addEventListener('change', function(){
    const selectedStore = this.value;
    styleBtn.setAttribute('href',selectedStore);
    styleBtn.setAttribute('target','_blank');
    styleBtn.classList.remove('disabled');
  });
  scrollToSection.addEventListener('click', function(){
    var selectedDiv = this.getAttribute('href');
   document.getElementById(selectedDiv).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
      })();
